import { Card } from "shared/components/Card";
import { Loader } from "shared/components/Loader";

export const ShowingsCard = ({
  title,
  count,
  isLoading,
  onClick
}: {
  title: string;
  count: number | undefined;
  isLoading: boolean;
  onClick: () => void;
}) => (
  <Card onClick={onClick} className="space-y-2 p-6">
    <p className="text-sm font-medium text-content-1000">{title}</p>
    {isLoading ? (
      <Loader size={24} />
    ) : (
      <p className="text-2xl font-bold text-content-1000">{count ?? "-"}</p>
    )}
  </Card>
);
